// extracted by mini-css-extract-plugin
module.exports = {"mobile":"LeaveMsg_mobile__gOErl"};